import React from 'react';
import { IconProps } from '.';

const SvgStarFillRounded = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='M11.34 18.78c.37-.223.831-.223 1.2 0l4.22 2.547c.879.53 1.963-.258 1.73-1.258l-1.12-4.8c-.098-.42.045-.859.37-1.141l3.734-3.235c.776-.671.362-1.946-.66-2.034l-4.915-.424a1.16 1.16 0 0 1-.97-.703l-1.92-4.525c-.4-.943-1.737-.943-2.138 0l-1.92 4.525c-.168.396-.541.667-.97.703l-4.918.425c-1.022.088-1.436 1.36-.661 2.033L6.13 14.13c.324.282.467.72.37 1.139l-1.115 4.805c-.231 1 .853 1.787 1.731 1.256l4.224-2.549Z'
      />
    </svg>
  );
};

export default SvgStarFillRounded;
